var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nx-dialog',{attrs:{"className":"vbuy-dialog","content":_vm.titleText,"btns":_vm.dialogButtons,"showConfirmButton":false},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})}
var staticRenderFns = []

export { render, staticRenderFns }